import { useContext } from 'react';

import { AWSConnectContext } from 'providers/AWSConnectProvider';

const useAWSConnect = () => {
  const awsConnectContext = useContext(AWSConnectContext);
  return awsConnectContext;
};

export default useAWSConnect;
